import React, {useEffect, useState} from 'react'
import Layout from '../components/Layout'
import {fetchUser} from '../redux/features/user.feature'
import {useSelector, useDispatch} from 'react-redux';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column'
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {FilterMatchMode, FilterOperator} from "primereact/api";

const User = () => {
    const [start, setFirst] = useState(0);
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);


    useEffect(() => {
        initFilters1();
        dispatch(fetchUser())
    }, [])



    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {...filters1};
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }



    const initFilters1 = () => {
        setFilters1({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'name': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'username': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'email': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'website': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setGlobalFilterValue1('');
    }

    const clearFilter1 = () => {
        initFilters1();
    }
    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
                        onClick={clearFilter1}/>
                <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1}
                               placeholder="Keyword Search"/>
                </span>
            </div>
        )
    }


    const footer = `In total there are ${user.users ? user.users.length : 0} Users.`;


    const header1 = renderHeader1();


    const Table = (
        // <DataTable value={user.users} header={header} footer={footer}>
        <DataTable value={user.users}
                   // footer={footer}
                   paginator rows={4} first={start}
                   header={header1}
                   showGridlines
                   dataKey="id" filters={filters1} filterDisplay="menu"
                   globalFilterFields={['name', 'username', 'email', 'website']}
                   paginatorTemplate="RowsPerPageDropdown PageLinks FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
            <Column field="name" header="Name" filter filterPlaceholder="Search by name"/>
            <Column field='username' header="Username" filter filterPlaceholder="Search by Username" />
            <Column field='email' header="email"/>
            <Column field='website' header="website"/>

            {/* <Column header="username" body={imageBodyTemplate}></Column>
        <Column field="price" header="Price" body={priceBodyTemplate}></Column>
        <Column field="category" header="Category"></Column>
        <Column field="rating" header="Reviews" body={ratingBodyTemplate}></Column>
        <Column header="Status" body={statusBodyTemplate}></Column> */}
        </DataTable>
    )


    return (
        <Layout>
            {Table}
        </Layout>
    )
}

export default User